import axios from "axios";

export default function () {
	axios.interceptors.request.use(function (config) {
		// config.baseURL = store.state.API_BASE;
		config.baseURL = process.env.VUE_APP_BASE_URL;
		return config
	}, function (err) {
		return Promise.reject(err)
	})
	
	axios.interceptors.response.use(function (response) {
		return response;
	}, function (err) {
		if (err.response) {
			console.log('Interceptor Error!', err.response)
		} else {
			// store.dispatch('alert/error', 'Some unusual error happened');
		}
		return Promise.reject(err)
	})
}
